import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    exhibitContainer: {
      // background: '#000',
      display: 'flex',
      flex: '1 1 auto',
    },
    displayError: {
      padding: 20,
      textAlign: 'center',
      color: 'white',
    },
  });
};
